import transport from "core/model/api/transport";

type ConclusionType =
  | "action_required"
  | "cancelled"
  | "failure"
  | "neutral"
  | "success"
  | "timed_out";
type StatusType = "completed" | "in_progress" | "queued";

export function updateChromaStatus({
  conclusion,
  sha,
  status,
  url,
}: {
  conclusion: ConclusionType;
  sha: string;
  status: StatusType;
  url?: string;
}) {
  return transport.post({
    body: {
      conclusion,
      sha,
      status,
      url,
    },
    options: { url: "https://router-pr.staging.recaresolutions.com" },
    route: "/checks",
  });
}
